import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-info-kategorie2';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungInfoKategorie2Effects {

    VeranstaltungInfoKategorie2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_INFO_KATEGORIE2),
        mergeMap((x: ac.GetVeranstaltungInfoKategorie2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungInfoKategorie2(x.veranstaltung_id, x.kategorieId).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungInfoKategorie2ErfolgreichAction(result, x.veranstaltung_id, x.kategorieId, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungInfoKategorie2FehlerAction(error, x.veranstaltung_id, x.kategorieId, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.InfoKategorienQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.InfoKategorienQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.InfoKategorienQueryService);
        }
        return this.service;
    }
}
